import { render } from "./ColorSwatch.vue.js?vue&type=template&id=4613fed1&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorSwatch.vue?vue&type=template&id=4613fed1&scoped=true"
import script from "./ColorSwatch.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorSwatch.vue?vue&type=script&lang=js"

import "./ColorSwatch.vue.scss?vue&type=style&index=0&id=4613fed1&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorSwatch.vue?vue&type=style&index=0&id=4613fed1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4613fed1"],['__file',"src/SharedWeb/scripts/components/color-picker/ColorSwatch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4613fed1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4613fed1', __exports__)) {
    api.reload('4613fed1', __exports__)
  }
  
  module.hot.accept("./ColorSwatch.vue.js?vue&type=template&id=4613fed1&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ColorSwatch.vue?vue&type=template&id=4613fed1&scoped=true", () => {
    api.rerender('4613fed1', render)
  })

}


export default __exports__